<script>
    import { notificate } from "../../../../services/notification.js";
    import { form as svForm, field } from "svelte-forms";
    import { required } from 'svelte-forms/validators';
    import { removeTags } from '../../../../js/utils.js';
    import { format, locale } from 'svelte-i18n';
    import logbookService from "./service.js";

    let {
        fetchFunction,
        closeModal
     } = $props();

    //form fields
    const nameField = field('name', '', [required()]);
    const myForm = svForm(nameField);

    let formData = $state({});
    let formIsSubmitted = false;
    // API string errors
    let APIerror = $state(null);
    // API 422 errors
    let formApiErrors = {};

    // errors must be shown only when:
    //   field is invalid (dirty or after submit)
    //   or the API returned 422
    function shouldShowFieldError(field) {
        return (
            ((formIsSubmitted || field.dirty) && !field.valid)
            || (formApiErrors[field])
        );
    }


    async function handleSubmit() {
        event.preventDefault();
        formIsSubmitted = true;
        // reset API errors
        formApiErrors = {};

        await nameField.validate();

        if ($myForm.hasError("name.required")) {
            notificate('422');
            return false;
        }

        formData = {
            name: $nameField.value,
        };

        for(let [k, v] of Object.entries(formData)){
            if(typeof v == 'string'){
                formData[k] = removeTags(v);
            }
        }

        logbookService.save(formData, [], {})
            .then(async response=>{
                formIsSubmitted = false;
                formApiErrors = {};
                APIerror = null;
                await fetchFunction();
                closeModal();
                return true;
            })
            .catch(e=>e);

        formIsSubmitted = false;
        formApiErrors = {};
        APIerror = null;
        return true;
    }

    const handleKeydown = event => {

        if(event.key == "Escape"){
            closeModal();
        }
        else {
            return;
        }
    }
</script>
<style>
    .alert.alert-warning {
        color: #856404;
        background-color: #fff3cd;
    }
</style>

<svelte:window onkeydown={handleKeydown}/>
<form role="form" novalidate onsubmit={handleSubmit}>
    <div class="card">
        <div class="card-body">
            <div class="mb-3">
                <label for="name">
                    Crear bitácora
                    <span title="Requerido" class="text-danger">*</span></label>
                <input
                    type="text"
                    class="form-control t-input-logbook-name"
                    id="logbookAddName"
                    name="name"
                    placeholder="Nombre de bitácora"
                    bind:value={$nameField.value}
                    onchange={async()=>await nameField.validate()}
                    class:is-invalid={shouldShowFieldError($nameField)}
                />
                {#if APIerror}
                    <div class="mt-3 text-danger" style="font-size: 80%;">{APIerror}</div>
                {/if}
                {#if shouldShowFieldError($nameField)}
                    {#if $myForm.hasError('name.required')}
                        <div class="invalid-feedback">
                            {$format("required")}
                        </div>
                    {/if}
                {/if}
            </div>
        </div>
        <div class="card-footer">
            <button id="logbookAddSubmit" type="submit" class="btn btn-primary t-submit-logbook-btn">{$format("buttons.save")}</button>
            <button type="button" class="btn btn-default" onclick={closeModal} data-bs-dismiss="modal">{$format("buttons.cancel")}</button>
        </div>
    </div>
</form>
